import { forwardRef } from "react";
import { Select, MenuItem, InputAdornment } from "@mui/material";
import { formats } from "./constants";
import { InputSelectAdornmentProps, InputMaskProps } from "./types";

export const PhoneNumberTextMask = forwardRef<HTMLElement, InputMaskProps>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;

  const formatValue = (rawValue: string | null | undefined) => {
    const mask = "(#00) 000-0000";
    if (!mask) return rawValue ?? "";

    const digits = (rawValue || "").replace(/\D/g, "");

    let formatted = "";
    let digitIndex = 0;

    for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
      const maskChar = mask[i];

      if (maskChar === "#") {
        // First digit must be 1-9
        const digit = digits[digitIndex];
        if (digit >= "1" && digit <= "9") {
          formatted += digit;
          digitIndex++;
        } else if (digitIndex === 0) {
          // Skip invalid first digit
          digitIndex++;
          i--; // Retry this mask position with next digit
        }
      } else if (maskChar === "0") {
        // Any digit 0-9
        formatted += digits[digitIndex];
        digitIndex++;
      } else {
        // Literal character (parentheses, space, dash)
        formatted += maskChar;
      }
    }

    return formatted;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatValue(event.target.value);

    onChange({ target: { name: props.name, value: formattedValue } });
  };

  const inputValue = (other as any).value || "";

  return <input {...other} ref={ref as any} value={formatValue(inputValue)} onChange={handleChange} />;
});

export const InputSelectAdornment = ({ value, onChange, readOnly, disabled, size }: InputSelectAdornmentProps) => {
  return (
    <InputAdornment position="start" sx={{ marginTop: "0px !important" }} disablePointerEvents={disabled}>
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        sx={(theme) => ({
          backgroundColor: !disabled ? theme.palette.primary.light : theme.palette.secondary.light,
          minWidth: "80px",
          borderTopRightRadius: "0px !important",
          borderBottomRightRadius: "0px !important",
        })}
        readOnly={readOnly || disabled}
        size={size}
      >
        {formats.map((format) => (
          <MenuItem value={format} key={`format_${format}`}>
            {format}
          </MenuItem>
        ))}
      </Select>
    </InputAdornment>
  );
};
